import { Component, Input, OnInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ChartConfiguration, Tooltip } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { CvNumberLocalizePipe } from '../../../../../../reusables/pipes/cv-number-localize.pipe';

@Component({
    selector: 'cv-games-running-by-type',
    templateUrl: './games-running-by-type.component.html',
    styleUrls: ['./games-running-by-type.component.scss']
})
export class GamesRunningByTypeComponent implements OnInit, OnChanges {
    @Input() activeGames: any;
    @ViewChild(BaseChartDirective) chartObject: BaseChartDirective;

    gs: any = null;
    localization = new Map();

    //Chart variables
    gameCounts = [];
    gameTypeLabels = [];
    gameTypeColors = [];
    elementContext = null;
    firstAnimateComplete = false;

    colorsByGameType = {
        1: 'rgb(243, 135, 148)',
        2: 'rgb(235, 164, 111)',
        3: 'rgb(123, 204, 200)',
        4: 'rgb(106, 192, 125)',
        5: 'rgb(130, 180, 224)',
        6: 'rgb(190, 159, 202)',
        7: 'rgb(49, 165, 189)',
        8: 'rgb(106, 192, 125)',
        9: 'rgb(237, 218, 105)',
        10: 'rgb(138, 136, 241)'
    };
    chartConfig = null;

    constructor(
        private gamesService: GamesService,
        private cvNumberLocalizePipe: CvNumberLocalizePipe
    ) {
        this.gs = this.gamesService.data;
    }

    ngOnInit(): void { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.activeGames) {
            const gameCountsByType = [];

            //Count active games by game type
            changes.activeGames.currentValue.forEach((game) => {
                const gameType = game.underlyingRule.GameType;
                if (!gameCountsByType[gameType]) {
                    gameCountsByType[gameType] = 0;
                }

                gameCountsByType[gameType]++;
            });

            //Empty arrays
            this.gameCounts.splice(0, this.gameCounts.length);
            this.gameTypeLabels.splice(0, this.gameTypeLabels.length);
            this.gameTypeColors.splice(0, this.gameTypeColors.length);

            //Fill arrays with types
            gameCountsByType.forEach((count, gameType) => {
                this.gameTypeColors.push(this.colorsByGameType[gameType]);
                this.gameTypeLabels.push(this.gs.gameTypes.textFromValue(Number(gameType)));
                this.gameCounts.push(this.cvNumberLocalizePipe.transform(count));
            });

            this.createChart();
        }
    }

    createChart(): void {
        //Check for empty datasets
        if (this.gameCounts === null) {
            return;
        }

        this.chartConfig = {
            type: 'doughnut',
            data: {
                datasets: [{
                    data: this.gameCounts,
                    backgroundColor: this.gameTypeColors
                }],
                labels: this.gameTypeLabels
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                    legend: {
                        position: 'bottom'
                    },
                    tooltip: {
                        callbacks: {
                            title: tooltipItem => "",
                            label: tooltipItem => tooltipItem.label + ": " + tooltipItem.dataset.data[tooltipItem.dataIndex],
                        }
                    },
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                }
            }
        } as ChartConfiguration;

        this.chartConfig.data.datasets[0].data = this.gameCounts;
        this.chartObject?.chart.update();
        this.firstAnimateComplete = true;
    }
}